import React from 'react';
import PropTypes from 'prop-types';

const TabPanel = ({ index, selectedTab, children, className }) => {
  return index === selectedTab ? <div className={`${className}`}>{children}</div> : null;
};

TabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  selectedTab: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

TabPanel.defaultProps = {
  className: '',
};

export default TabPanel;
